interface LogLevel {
  error: number;
  warn: number;
  info: number;
  debug: number;
}

export class Logger {

  public static LEVEL: LogLevel = {
    error: 3,
    warn: 4,
    info: 5,
    debug: 6
  };

  public static LOGLEVEL: number = Logger.LEVEL.warn;

  private static log(level: number, message: string): void {
    // TODO: how should errors be shown https://tfs.tsi.lan/tfs/DefaultCollection/Tableau-Dev/_workitems?id=849134
    if (level > Logger.LOGLEVEL) {
      return;
    }

    let levelStr = '';
    switch (level) {
      case 3:
        levelStr = 'ERROR';
        break;
      case 4:
        levelStr = 'WARN';
        break;
      case 5:
        levelStr = 'INFO';
        break;
      default:
        levelStr = 'DEBUG';
    }
    console.log(`${levelStr} : ${message}`);
  }

  public static error(message: string): void {
    this.log(Logger.LEVEL.error, message);
  }

  public static warn(message: string): void {
    this.log(Logger.LEVEL.warn, message);
  }

  public static info(message: string): void {
    this.log(Logger.LEVEL.info, message);
  }

  public static debug(message: string): void {
    this.log(Logger.LEVEL.debug, message);
  }

}
